import { FC } from 'react';

import { Card, VSpacing, Text } from '@hh.ru/magritte-ui';

import HumanDate, { ShowYear } from 'src/components/HumanDate';
import { CommentProps } from 'src/components/ResumeComments/Item';
import { COMMA, REGULAR_SPACE } from 'src/utils/constants/symbols';

import CommentFormEdit from 'src/components/ResumeCard/Actions/Comments/Comment/FormEdit';

import styles from './index.less';

const Comment: FC<CommentProps> = ({ body, renderControls, author, date, renderForm, expandComment, isEditing }) => (
    <>
        <VSpacing default={20} />
        <div data-qa="resume-serp__resume-comment" data-interactive>
            {renderForm({ renderWrapper: CommentFormEdit })}
            {!isEditing && (
                <>
                    <Card padding={16} borderRadius={12} borderWidth="default" stretched>
                        <div className={styles.body}>
                            <Text
                                typography="label-3-regular"
                                onClick={expandComment}
                                data-qa="resume-serp__resume-comment-text"
                            >
                                {body}
                            </Text>
                            {renderControls()}
                        </div>
                    </Card>
                    <div className={styles.details}>
                        <VSpacing default={8} />
                        <Text style="secondary" typography="label-3-regular">
                            {author}
                            {COMMA}
                            {REGULAR_SPACE}
                            <HumanDate date={date} showClock showYear={ShowYear.NotCurrent} />
                        </Text>
                    </div>
                </>
            )}
        </div>
    </>
);

export default Comment;
